<select class="form-select form-select-lg" [(ngModel)]="value" [disabled]="isDisabled" (change)="onChanged($event)"
  (blur)="onBlur()">
  <option *ngFor="let item of items" [value]="item.value">{{item.label}}</option>
</select>
